"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = void 0;
const super_admin_folder_service_1 = require("./super-admin-folder.service");
class Storage {
    constructor(app) {
        this.root = app.storage().ref();
    }
    folders() {
        return {
            superAdmin: new super_admin_folder_service_1.SuperAdminFolder(this.root),
        };
    }
}
exports.Storage = Storage;
